import { Apps, BaselineCountryCodes } from './app'

// 以下导出由 /products/tree 派生，加载前为空，见 ./app.js 与 ./product-tree.js

export const PGames = []

export const Products1 = []

// [{ code: 'total' }, 分组 { code, name, pids }, ...产品 { code, name, group }]
export const Products = []

// 分组码 → 后代 pid（与服务端 guard 的分组展开同源）
export const PID_GROUP = {}

export { Apps, BaselineCountryCodes }

// [{ code: 'total', name: 'Total' }, ...国家]，核心国名字带「 *」
export const Countries = []
